/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center"></h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container ">
        <br>
        <div class="text-center title"><b>Où trouver votre numéro de permis ou code NPEH ?</b></div>
        <br>
        <ul>
          <li>
            Sur le <b>nouveau permis</b> au format carte bancaire européen, le numéro de dossier se trouve au verso (au dos de la carte) en haut à gauche au dessus de la puce sur 2 lignes horizontales.
          </li>
          <img style="margin-top: 10px; width: 100%" src="assets/new-permis.png">
          <br>
          <li>
            Sur le <b>permis ancien format</b>, le numéro de permis se trouve à l'intérieur sur le premier volet, en dessous de la date d'obtention de votre permis de conduire.
          </li>
          <img style="margin-top: 10px; width: 100%" src="assets/old-permis.png">
        </ul>
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">
.title {
  color: var(--ion-color-primary);
}

</style>

<script>
  import {toast} from "../../Shared/Mixin/toast.mixin";

  export default {
    name: 'infos-permis',
    data () {
      return {
        loading: false,
      }
    },
    mixins: [toast],
    props : [],
    created() {

    },
    methods: {

    }
  }
</script>
